/* eslint-disable react/forbid-elements */
import BeamLogo from '../../../assets/beam.png'
import BiteLogo from '../../../assets/bite.png'
import DoeLogo from '../../../assets/doe.png'
import GfuelLogo from '../../../assets/gfuel.png'
import OlipopLogo from '../../../assets/olipop.png'
import TopicalsLogo from '../../../assets/topicals.png'
import {
  YStack,
  Button,
  LinkButton,
  H2,
  Paragraph,
  XStack,
  useMedia,
} from '@bounty/creators-design-system'
import { useBrandSignUpModal } from './SignUpModal'

export const CallToAction = () => {
  const { gtMd } = useMedia()
  const [, setOpen] = useBrandSignUpModal()

  return (
    <YStack backgroundColor={'rgba(92, 225, 230, 1)'} px="$6" py="$14">
      <YStack
        width="100%"
        maxWidth={1300}
        alignSelf="center"
        $gtMd={{ flexDirection: 'row', justifyContent: 'space-between' }}
      >
        <YStack>
          <YStack mb="$8">
            <H2 size="$xl" color="$neutral.50" mb="$1">
              Automate your UGC today.
            </H2>
            <Paragraph color="$neutral.50">
              Join top brands growing with Bounty.
            </Paragraph>
          </YStack>

          <XStack flexWrap="wrap" width="100%" mb="$8" maxWidth={550}>
            <YStack pr="$4" pb="$5" $gtMd={{ pr: '$6', pb: '$6' }}>
              <img
                src={OlipopLogo}
                alt={'Olipop logo'}
                loading="lazy"
                style={{
                  objectFit: 'contain',
                  width: gtMd ? '104px' : '61px',
                }}
              />
            </YStack>
            <YStack pr="$4" pb="$5" $gtMd={{ pr: '$6', pb: '$6' }}>
              <img
                loading="lazy"
                src={TopicalsLogo}
                alt={'Topicals logo'}
                style={{
                  objectFit: 'contain',
                  width: gtMd ? '220px' : '104px',
                }}
              />
            </YStack>
            <YStack pr="$4" pb="$5" $gtMd={{ pr: '$6', pb: '$6' }}>
              <img
                loading="lazy"
                src={BeamLogo}
                alt={'Beam logo'}
                style={{
                  objectFit: 'contain',
                  width: gtMd ? '140px' : '62px',
                }}
              />
            </YStack>
            <YStack pr="$4" $gtMd={{ pr: '$6' }}>
              <img
                loading="lazy"
                src={GfuelLogo}
                alt={'GFuel logo'}
                style={{
                  objectFit: 'contain',
                  width: gtMd ? '128px' : '75px',
                }}
              />
            </YStack>
            <YStack pr="$4" $gtMd={{ pr: '$6' }}>
              <img
                loading="lazy"
                src={DoeLogo}
                alt={'Doe Lashes logo'}
                style={{
                  objectFit: 'contain',
                  width: gtMd ? '87px' : '52px',
                }}
              />
            </YStack>
            <YStack pr="$4" $gtMd={{ pr: '$6' }}>
              <img
                loading="lazy"
                src={BiteLogo}
                alt={'Bite logo'}
                style={{
                  objectFit: 'contain',
                  width: gtMd ? '84px' : '50px',
                }}
              />
            </YStack>
          </XStack>
        </YStack>
        <XStack space="$4">
          <LinkButton
            variant="outline"
            colorScheme="whiteAlpha"
            borderColor={'$neutral.50'}
            buttonTextProps={{ color: '$neutral.50' }}
            event="Brands Call to Action Talk to Sales Clicked"
            href="https://5jmb9.share.hsforms.com/2iaN_A4CKSk6S7z8RIyDHYA"
            size="$lg"
            target="_blank"
          >
            Schedule a Demo
          </LinkButton>
        </XStack>
      </YStack>
    </YStack>
  )
}
